<template>
  <div id="sideMenu" class="mt-5">
    <div class="text-left" shadow> 
      <template v-for="root in menuTree">
        <!-- กลุ่มที่มีเมนูย่อย (เช่น หมวดหมู่, E-Library) -->
        <div v-if="root.children.length" :key="`group-${root.id}`" class="mb-5">
          <p style="font-size: 24px" class="mb-3"><b>{{ root.name }}</b></p>
          <div class="side-menu-border" style="padding: 10px;">
            <button
              v-for="child in root.children"
              :key="child.id"
              @click="handleMenuClick(child)"
              :class="`btn btn-outline-white btn-block side-menu text-left pl-0 btnHover ${
                isActive(child) ? 'btnActive' : ''
              }`"
            >
              {{ child.name }}
            </button>
          </div>
        </div>

        <!-- เมนูเดี่ยว (เช่น ผู้สอนทั้งหมด, คอร์สเรียนทั้งหมด) -->
        <div v-else :key="`single-${root.id}`" class="side-menu-border mb-5" style="padding: 10px;">
          <button
            @click="handleMenuClick(root)"
            :class="`btn btn-outline-white btn-block side-menu text-left pl-0 btnHover ${
              isActive(root) ? 'btnActive' : ''
            }`"
          >
            {{ root.name }}
          </button>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "sideMenu",
  computed: {
    ...mapState({
      menus: (state) => state.Courses.menus,
    }),
    // แปลง flat list เป็น tree ตาม parent_id + เรียงด้วย sort_order
    menuTree() {
      const items = (this.menus || []).filter((m) => m.is_active);
      const roots = items
        .filter((m) => m.parent_id == null)
        .sort((a, b) => a.sort_order - b.sort_order);
      return roots.map((root) => ({
        ...root,
        children: items
          .filter((m) => m.parent_id === root.id)
          .sort((a, b) => a.sort_order - b.sort_order),
      }));
    },
  },
  mounted() {
    this.$store.dispatch("Courses/onGetMenus");
  },
  methods: {
    // แปลง url จาก backend ให้ตรงกับ route จริงในแอป
    resolveTo(rawUrl) {
      if (!rawUrl) return null;
      const [path, queryStr = ""] = rawUrl.split("?");
      const params = new URLSearchParams(queryStr);

      // E-Library: elibrary / elibrary?group=N → /favorite-menu-book?id=N (ไม่มี group = 0 = ทั้งหมด)
      if (path === "elibrary") {
        const id = params.get("group") || 0;
        return `/favorite-menu-book?id=${id}`;
      }

      // หมวดหมู่: courses?category=N → /category/N
      if (path === "courses") {
        const category = params.get("category");
        if (category) return `/category/${category}`;
      }

      // อื่นๆ ใช้ url ดิบ (เติม / นำหน้า)
      return rawUrl.startsWith("/") ? rawUrl : `/${rawUrl}`;
    },
    handleMenuClick(item) {
      // เมนูหัวข้อ (ไม่มีลิงก์)
      if (item.link_type === "none" || !item.url) return;

      // ลิงก์ภายนอก → เปิดแท็บใหม่
      if (item.link_type === "external") {
        window.open(item.url, item.target || "_blank");
        return;
      }

      // ลิงก์ภายใน (แปลง url ให้ตรงกับ route จริง)
      const to = this.resolveTo(item.url);
      if (item.target === "_blank") {
        const resolved = this.$router.resolve(to);
        window.open(resolved.href, "_blank");
        return;
      }
      // eslint-disable-next-line no-unused-vars
      this.$router.push(to).catch((err) => {});
    },
    isActive(item) {
      const to = this.resolveTo(item.url);
      return to != null && this.$route.fullPath === to;
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 990px) {
  #sideMenu {
    display: none;
  }
}

.side-menu-border>button {
  padding-left: 15px !important;
  padding-right: 15px !important;
}

/*button.side-menu:hover {*/
/*  background-color: #2c3143; !* Green *!*/
/*  color: white;*/
/*}*/
</style>
